import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import moment from "moment";
import * as ReactBootStrap from 'react-bootstrap';


import megusto from '../tools/images/iconomegustogris.svg'
import nomegusto from '../tools/images/icononomegusto.svg'
import meinteresa from '../tools/images/iconomeinteresa.svg'

import Reaccion_megusto from '../tools/images/iconomegusto.svg'
import Reaccion_nomegusto from '../tools/images/icononomegustomagenta.svg'
import Reaccion_meinteresa from '../tools/images/iconomeinteresamagenta.svg'

import cargamultimedia from '../tools/images/iconocargarfoto.svg'

import iconocargarvideo from '../tools/images/iconocargarvideo.svg'

import emptypage from '../tools/images/carpeta.gif';
import img_vacia from '../tools/images/imagen portada.jpg';
import Buscar from '../tools/images/Buscar';

import AwesomeSlider from 'react-awesome-slider';
import Estilo from 'react-awesome-slider/dist/styles.css';


import '../tools/css/Publicaciones.css';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';


import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL="https://medicall-api-test.azurewebsites.net";
const FILES_BASE_URL = ApiURL + "/api/Files?path=";
// A partir de cuántos caracteres se ofrece "Ver más" (heurística de "más de 3 líneas").
const UMBRAL_VER_MAS = 220;
// Avatar de reserva (silueta gris) para usuarios que reaccionaron sin foto de perfil.
const AVATAR_POR_DEFECTO = "data:image/svg+xml;utf8," + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'><circle cx='20' cy='20' r='20' fill='#e0e0e0'/><circle cx='20' cy='16' r='7' fill='#ffffff'/><path d='M6 35c0-9 7-14 14-14s14 5 14 14' fill='#ffffff'/></svg>"
)
var institution_id =sessionStorage.getItem('id_institution');
var mensaje='';
var buscar_publicacion='';
var tipo_publi='publico';
var num_file='Ningún archivo seleccionado';
var files=[];
var id_publicacion=0;
var tipo_reaccion='';
var textotipo_reaccion='';
var num_reaccion=0;
var icono_reaccion='';
var info_usuario='';
var img_completa='';
var nomInst='';
var fecha_publi=img_vacia;
var pagina=1;
var publica=[]
var id_detalle_publi='textarea_descripcion'


class Publicaciones extends Component {

  

  constructor(props)
    {
     super()
      this.state={
        show:false,
        DataIntitucion: [],    
        DataMembresia: [],   
        Publicaciones:[],
        Pager_Publicacione: [],
        imgs:[],
        Reacciones:[],
        Detalle_publi:[],
        pager_infopublicacione:'',
        loading: false,
        loading_button: true,
        active_button: true,
        loading_button_firma: true,
        active_button_firma: true,
        descripcionesExpandidas: {},


        form:{   
        nombre_inst:'',     
        id_inst:'',
        descrip_publi:'',
        selectedFile:null,
        id_publi:'',
        descrip_publi_edit:'',
        buscar_publicaciones:''
        
        }
        
      }
    }



    handleChange=async e=>{
      await this.setState({
         form:{
              ...this.state.form,
              [e.target.name]: e.target.value
              }
         })
         console.log(this.state.form);
    } 



    GetImge = (i) =>{
      if(i.target.files.length > 10){

        store.addNotification({
          title: 'Atención',
          message: "No puede seleccionar más de 10 archivos para una publicación ",
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

      }else{

      this.setState({imgs:i.target.files})
      files = i.target.files;     
      
      //files_view=URL.createObjectURL(i.target.files[0]);
      //console.log(i.target.value)
      num_file="Ha seleccionado "+(i.target.files.length)+" archivo(s)"
      $('#input_file').hide();
      $('#tabla_imgs').show();
      $('#btn_cancelar_seleccion ').show();

      }
           
     
    }

    GetVideo = (v) =>{
      if(v.target.files.length > 10){

        store.addNotification({
          title: 'Atención',
          message: "No puede seleccionar más de 10 archivos para una publicación ",
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

      }else{

      this.setState({imgs:v.target.files})
      files = v.target.files;     
      
      //files_view=URL.createObjectURL(i.target.files[0]);
      //console.log(i.target.value)
      num_file="Ha seleccionado "+(v.target.files.length)+" archivo(s)"
      $('#input_file').hide();
      $('#tabla_imgs').show();
      $('#btn_cancelar_seleccion ').show();

      }
           
     
    }

    Tipo_Publi = (p) =>{
      //this.setState({tipo_publicacion:p.target.value})
      console.log(p.target.value)
      tipo_publi=(p.target.value)
     
    }


    BuscarPublicacion = (bp) =>{
      this.setState({buscar_publicaciones:bp.target.value})
      console.log(bp.target.value)
      buscar_publicacion=(bp.target.value)
      this.searchDatapublicacion(buscar_publicacion)
     
    }

    
    
    handleModalpublicacion()
    { 
      $('#input_file').show();  
      $('#tabla_imgs').hide();  
      $('#btn_cancelar_seleccion ').hide();
      
      $("#modal-agregar-publicacion input").val(""); 
      $("#modal-agregar-publicacion textarea").val("");
      $('#modal-agregar-publicacion').modal('show'); // <- to show modal publicacion

      this.setState({
        form:{
        descrip_publi:'' 
      }
    })

      num_file='Ningún archivo seleccionado';

    }


    handledrop_form()
    {   
      
      $('#tabla_imgs').hide();
      $('#btn_cancelar_seleccion ').hide();  
      
      $("#modal-agregar-publicacion input").val(""); 
      $("#modal-agregar-publicacion textarea").val("");


      this.setState({
        form:{
        descrip_publi:'' 
      }
    })

      num_file='Ningún archivo seleccionado';

    }


    cencelar_seleccion()
    { 
      $('#input_file').show();      
      $('#tabla_imgs').hide(); 
      $('#btn_cancelar_seleccion ').hide();

      $("#modal-agregar-publicacion input").val(""); 

      this.setState({
        form:{
        descrip_publi:this.state.form.descrip_publi 
      }
    })


      num_file='Ningún archivo seleccionado';

    }


    empty_page_hide(){
      $('#tabla_p').hide();     
      $('#empty_page').hide();
      $('#text_page').hide();
      
    }


    handleModaleliminarpublicacion()
    {      
      $('#modal-eliminar_publicacion').modal('show'); // <- to show modal crear sede 
    }


    handleModalpublicacionedit()
    {     
      $('#modal-publicacionedit').modal('show'); // <- to show modal editar contrato 
    }


    geolocalizacion(){
      if (navigator.geolocation)
      {
      	alert("Geolocalización Activa")
      }
      else
      {
      	alert("Geolocalización Inactiva")
      }
    }
    
   
    componentDidMount(){
      this.Datos_Institucion();
      this.loadMorePublicacion();
    }

    /** Detecta si el recurso de una publicación es un video por su extensión en la URL. */
    esVideo(url){
      if(!url) return false
      return /\.(mp4|mov|avi|wmv|webm|mkv)(\?|$)/i.test(url)
    }

    toggleDescripcion(id){
      this.setState((previo)=>({
        descripcionesExpandidas: { ...previo.descripcionesExpandidas, [id]: !previo.descripcionesExpandidas[id] }
      }))
    }



    seleccionar_publicacion=(publi)=>{
      this.setState({
        form:{
          id_publicacion:publi.id,  
          descrip_publi_edit:publi.description
        }
      })
      //var  dato  = solicitud.user.identification;
      //alert(dato);
    }


    Datos_Institucion(){    
      
      axios.get(ApiURL+"/api/Institutions/GetInstitution/"+institution_id)
      .then((response) => {
        console.log(response);
        this.setState({DataIntitucion: response.data.institution})       
        this.setState({DataMembresia: response.data.membership})
        nomInst=this.state.DataIntitucion.name.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));

      })
      .catch((error) => {
        console.log(error);
      })
    }


    Cargar_publicaciones(){  

      this.empty_page_hide();
      
      this.setState({ loading: this.state.loading = false })
    
      axios.get(ApiURL+"/api/Posts/GetAllPosts")
      .then((response) => {
        //console.log(response);

        this.setState({Publicaciones: response.data.data})
        this.setState({Pager_Publicacione: response.data.pager.items})
        this.setState({pager_infopublicacione: response.data.pager.showData})

        if(this.state.Publicaciones.length==0){
          $('#tabla_p').hide();
          $('#empty_page').show();
          $('#text_page').show();
        }else{
          $('#tabla_p').show();
          $('#empty_page').hide();
          $('#text_page').hide();
        }

        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })

    }


    loadMorePublicacion() {
      //var page=page_pendien.pagina
      //this.empty_page_hide();
      this.setState({ loading: this.state.loading = false })
      
      axios.get(ApiURL+"/api/Posts/GetAllPosts?numeroPagina="+pagina)
      .then((response) => {
        console.log(response);

        this.setState({Publicaciones: response.data.data})
        publica=publica.concat(this.state.Publicaciones)
        this.setState({Pager_Publicacione: response.data.pager.items})
        this.setState({pager_infopublicacione: response.data.pager.showData})

        if(this.state.Publicaciones.length==0){
          //$('#tabla_p').hide();
          $('#empty_page').show();
          $('#text_page').show();
        }else{
          //$('#tabla_p').show();
          $('#empty_page').hide();
          $('#text_page').hide();
        }

       
        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    
      }

      searchDatapublicacion(buscar_pendiente) {

        this.setState({ loading: this.state.loading = false })
        
        axios.get(ApiURL+"/api/Posts/GetAllPosts?texto="+buscar_pendiente)
        .then((response) => {

        //console.log(response);
        this.setState({Publicaciones: response.data.data})
        this.setState({Pager_Publicacione: response.data.pager.items})
        this.setState({pager_infopublicacione: response.data.pager.showData})        
  
        
        this.setState({ loading: this.state.loading = true })
        })
        .catch((error) => {
          console.log(error);
        })
      
        }


        Save_publicacion=async()=>{
         
          if( this.state.form.descrip_publi.length==0 || files.length==0 ){
    
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos por ingresar",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
    
          }else{
    
            this.setState({ loading_button: this.state.loading_button = false })
            this.setState({ active_button: this.state.active_button = false })
    
            let formData = new FormData();
            
            
            
            formData.append('Description', this.state.form.descrip_publi)  
            for (const e of files) { 
              formData.append('Resources', e, e.files);
           }      
            formData.append('public', tipo_publi)
    
            await axios.post(ApiURL+"/api/Posts/Create", formData,{
    
              headers: {
                'Content-Type': 'multipart/form-data'            
              }
    
            }) 
      
            .then(response=>{
    
              console.log(response.data)
                     
              //this.setState({
                //Type_servicenew:response.data.agreement.typeServiceAgreements,
                //Servi_convenionew:response.data.agreement.serviceAgreements
              //})
              //alert(id_convenio);
              //const [text, setText] = LocalStorage(text, '')
              //setText(dato);
                     
              //window.location.href="/home";
              store.addNotification({
                title: 'Muy bien',
                message: "La publicación se guardó",
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
    
              this.setState({ loading_button: this.state.loading_button = true })
              this.setState({ active_button: this.state.active_button = true })
              
              $('#modal-agregar-publicacion').modal('hide');
              this.Cargar_publicaciones();
              
            })
            .catch(error=>{
              
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ loading_button: this.state.active_button = true })
    
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
            //console.log(error.config);
          
          })
    
          }
      
        }

      

        Editar_publicacion=async()=>{

          if(this.state.form.id_publicacion=='' || this.state.form.descrip_publi_edit=='' || this.state.form.descrip_publi_edit.length==0){
    
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos por ingresar",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
    
          }else{
    
            this.setState({ loading_button: this.state.loading_button = false })
            this.setState({ active_button: this.state.active_button = false })
    
            await axios.put(ApiURL+"/api/Posts/EditDescription",  
            {
              id: this.state.form.id_publicacion,
              description:this.state.form.descrip_publi_edit
            } )          
      
            .then(response=>{
              console.log(response.data)
              mensaje  = response.data.message;
              //alert(mensaje);
              //const [text, setText] = LocalStorage(text, '')
              //setText(dato);          
                     
              //window.location.href="/home";
              store.addNotification({
                title: 'Muy bien',
                message: mensaje,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
    
              this.setState({ loading_button: this.state.loading_button = true })
              this.setState({ active_button: this.state.active_button = true })
    
              this.Cargar_publicaciones();
              $('#modal-publicacionedit').modal('hide');
              
            })
            .catch(error=>{
             
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
    
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
            //console.log(error.config);
          
          })
            
          }      
      
        }


        Modal_borrar_publicacion(publi){

          id_publicacion  = publi.id;
    
          this.handleModaleliminarpublicacion();
    
        }

    
         Borrar_publicacion=async()=>{
         

          axios.delete(ApiURL+"/api/Posts/Delete/"+id_publicacion)
          .then((response) => {
            console.log(response.data)
              mensaje  = response.data.message;
              //alert(mensaje);
              //const [text, setText] = LocalStorage(text, '')
              //setText(dato);          
                     
              //window.location.href="/home";
              store.addNotification({
                title: 'Muy bien',
                message: mensaje,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })    
              
              this.Cargar_publicaciones();
            
          })
          .catch((error) => {
            console.log(error);
          })
        }


        Detalle_publicacion(publi){
        
         
          fecha_publi=publi.date
          id_publicacion = publi.id;    
            
        
          axios.get(ApiURL+"/api/Posts/GetPost?id="+id_publicacion)
          .then((response) => {
          console.log(response.data.resourcePosts);
    
            this.setState({Detalle_publi: response.data.resourcePosts})

            //$('#modal-detallepubli').modal('show');

            

            //alert(this.Detalle_publi.image);

            //this.handleModalreacciones();
           
          })
          .catch((error) => {
            console.log(error);
          })
    
        }

        Detalle_imagen(file){


          img_completa = FILES_BASE_URL + file.image

          if(this.esVideo(file.image)){

            $('#imgsdetalle').hide();
            $('#vdsdetalle').show();

          } else{

            $('#imgsdetalle').show();
            $('#vdsdetalle').hide();

          }

          $('#modal-detallepubli').modal('show');

        }

        DropDetalle_imagen(){

          img_completa=img_vacia

          //$('#imgsdetalle').hide();
          //$('#vdsdetalle').hide();

        }

        /** Indicador de reacción tipo pill (no clicable: esta vista no muestra quién reaccionó). */
        renderBotonReaccion(publi, tipo, opciones){
          const { cantidad, etiqueta, iconoInactivo, iconoActivo } = opciones
          const activa = cantidad > 0
          return (
            <button type="button" className={"feed-post__reaction" + (activa ? " feed-post__reaction--active" : "")} disabled>
              <img src={activa ? iconoActivo : iconoInactivo} alt={etiqueta} />
              <span>{etiqueta}</span>
              {activa ? <span className="feed-post__reaction-count">{cantidad}</span> : null}
            </button>
          )
        }

        /** Tarjeta de publicación con el mismo estilo "feed" usado en Publicaciones_prestador.js. */
        renderTarjetaPublicacion(publi){
          const archivos = publi.resourcePosts || []
          const expandida = !!this.state.descripcionesExpandidas[publi.id]
          const necesitaVerMas = (publi.description || '').length > UMBRAL_VER_MAS
          const mismaInstitucion = institution_id == publi.institution.id
          return (
            <div className="feed-post" key={publi.id}>
              <div className="feed-post__header">
                <img className="feed-post__avatar" src={FILES_BASE_URL + publi.institution.avatar} alt={publi.institution.name} />
                <div className="feed-post__meta">
                  <span className="feed-post__author">{publi.institution.name}</span>
                  <span className="feed-post__time"><Moment fromNow locale='es'>{publi.date}</Moment></span>
                </div>
              </div>
              <div className="feed-post__media">
                <AwesomeSlider cssModule={Estilo}>
                  {archivos.map((archivo, indice) => {
                    const url = FILES_BASE_URL + archivo.image
                    const video = this.esVideo(archivo.image)
                    return (
                      <div key={indice} className="feed-post__slide">
                        {video ? (
                          <video src={url} className="feed-post__media-el" controls preload="metadata" />
                        ) : (
                          <img src={url} className="feed-post__media-el feed-post__media-el--clickable" alt="Publicación" onClick={() => { this.Detalle_publicacion(publi); this.Detalle_imagen(archivo) }} />
                        )}
                      </div>
                    )
                  })}
                </AwesomeSlider>
              </div>
              <div className="feed-post__body">
                <div className="feed-post__actions">
                  {this.renderBotonReaccion(publi, 'me gustó', { cantidad: publi.likes, etiqueta: 'Me gustó', iconoInactivo: megusto, iconoActivo: Reaccion_megusto })}
                  {this.renderBotonReaccion(publi, 'no me gustó', { cantidad: publi.notLikes, etiqueta: 'No me gustó', iconoInactivo: nomegusto, iconoActivo: Reaccion_nomegusto })}
                  {this.renderBotonReaccion(publi, 'me interesa', { cantidad: publi.interested, etiqueta: 'Me interesa', iconoInactivo: meinteresa, iconoActivo: Reaccion_meinteresa })}
                </div>
                <p className={"feed-post__description" + (necesitaVerMas && !expandida ? " feed-post__description--clamped" : "")}>{publi.description}</p>
                {necesitaVerMas ? <button type="button" className="feed-post__toggle" onClick={() => this.toggleDescripcion(publi.id)}>{expandida ? 'Ver menos' : 'Ver más'}</button> : null}
                {mismaInstitucion ? <div className="feed-post__audience"><i className="fas fa-users"></i> Publicado para: {publi.public}</div> : null}
              </div>
            </div>
          )
        }



    render(){
      const {form} = this.state;

      const scrollToEnd = () =>{
        pagina++;
        //publica=publica
        this.loadMorePublicacion();
      }

      window.onscroll=function(){
       
        if(window.innerHeight + document.documentElement.scrollTop
          === document.documentElement.offsetHeight
          ){

            scrollToEnd()

        }
      }

     return (

     
      <div className="content-wrapper">

            <div className="col-12 col-sm-12 feed-page">

                  <div className="feed-toolbar feed-toolbar--center">
                    <h1 className="feed-toolbar__title feed-toolbar__title--brand">PUBLICACIONES</h1>
                  </div>

                  <div className="feed-search">
                    <Buscar/>
                    <input type="search" className="feed-search__input" placeholder="Buscar publicaciones..." name="buscar_solicitadas" onChange={this.BuscarPublicacion}/>
                  </div>

                  {this.state.loading ? <div className="feed-loading"><ReactBootStrap.Spinner animation="border" /></div> : null}

                  <div id="tabla_p">

                        {publica.map(publi=> this.renderTarjetaPublicacion(publi))}

                        {/* <span>{this.state.pager_infopublicacione}</span>
                        <nav className="nav">

                            <ul className="pagination">
                                {this.state.Pager_Publicacione.map(page_pendien=>{

                                  var activo=page_pendien.activo
                                  if(activo==true){
                                    activo='page-item active'
                                  }else{
                                    activo='page-item'
                                  }
                                 // alert(activo)

                                 return(

                                         <li className={activo}>
                                           <a className="nav-link" onClick={()=>{this.loadMorePublicacion(page_pendien)}}>{page_pendien.texto}</a>
                                         </li>
                                   )
                                  }
                                 )
                                }
                            </ul>

                        </nav> */}

                  </div>

                  <div className="feed-empty">
                       <img id="empty_page" src={emptypage} alt="Sin publicaciones" width="160"/>
                       <h5 id="text_page"><b>No hay información que mostrar</b></h5>
                  </div>

            </div>

            <div className="modal fade" id="modal-agregar-publicacion" data-backdrop="static">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header feed-modal-header">
                    <h4 className="col-11 modal-title text-center"><b>Crear publicación</b></h4>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=> this.handledrop_form()}>
                        <span aria-hidden="true">×</span>
                    </button>                    
                  </div>
                  <div className="modal-body">
        
                      <div className="row">
        
                          <div className="col-md-12">
        
                                <div className="form-group">                    
                                    <label >Descripción de la publicación:</label>                           
                                    <textarea className="form-control" rows="4" id="descrip_publi" name="descrip_publi" placeholder="Ingrese el texto de la publicación..."  onChange={this.handleChange} >{form.descrip_publi}</textarea>
                                    
                                </div>
        
                          </div>
        
                      </div> 


                      <div className="row">
        
                          <div className="col-md-12">

                                <div className="form-group">                    
                                  <label >Publicar para:</label>
                                  <select onChange={this.Tipo_Publi} className="form-control" id="tipo_publicacion" name="tipo_publicacion">
                    
                                    <option  value="publico">Publico</option>
                                    <option  value="profesionales">Profesionales de la salud</option>   
                                    <option  value="pacientes">Pacientes</option>                        
                                  
                                  </select>                      
                                </div> 
                  
                          </div>
                      
                      </div>

                      <div className="form-group text-center">                    
                          <label >Seleccione los archivos:</label>
                         
                      </div>
                                     
        
                      <div className="row" id="input_file">               
                                        
                          <div className="col-md-12 col-auto text-center"> 

                                <div className="form-group">    


                                    <div className="custom-file">
                                          <input type="file" name="selectedFile" id="exampleInputFile" multiple="true" className="inputfile inputfile-5" accept="image/jpg,image/JPG,image/jpeg,image/bmp,image/png,image/PNG,video/avi,video/mp4,video/wmv" onChange={this.GetImge}/>
                                      
                                          <label htmlFor="file-5" for="exampleInputFile">
                                            <figure>
                                            <img src={cargamultimedia}/>
                                            </figure>
                                            {/*<span className="iborrainputfile">{num_file}</span>*/}
                                          </label>
                                    </div>
                                                         
                                </div>                                                           
                          </div> 

                                         
            
                      </div> 

                      <div className="row" id="tabla_imgs"> 

                          <div className="col-md-12">                                    
                       
                                {this.state.imgs && [...this.state.imgs].map((file)=>{

                                  let src,preview,type=file.type;
                                   
                                  // Coincide con la cadena que comienza con image /
                                  if (/^image\/\S+$/.test(type)) {
                                      src = URL.createObjectURL(file)
                                      preview = <img id="imgs" src={src} alt="logo" width= "430" className="rounded" />
                                  }else{
                                        if (/^video\/\S+$/.test(type)) {
                                          src = URL.createObjectURL(file)
                                          preview = <video id="vdos" src={src} width= "430" loop controls />
                                      }
                                  }
                                  return(                              
                                   preview
                                )})}

                          </div>                      

                      </div>

                      {num_file}                      
                 
                  </div>

                  <div className="modal-footer justify-content-between">        
                    <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.Save_publicacion()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Publicar</button>
                    <button type="button" id="btn_cancelar_seleccion" className="btn btn-default" disabled={!this.state.active_button} onClick={()=> this.cencelar_seleccion()}>Cancelar selección</button>
                    <button type="button" className="btn btn-danger" disabled={!this.state.active_button} data-dismiss="modal" onClick={()=> this.handledrop_form()}>Cerrar</button>
                  </div>
                </div>
               
              </div>
             
            </div>


            <div className="modal fade" id="modal-publicacionedit">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header feed-modal-header">
                    <h4 className="modal-title"><b>Editar publicación</b></h4>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>

                  <div className="modal-body">
                    
                        <div className="row">
            
                              <div className="col-md-12">
                                    <div className="form-group">                    
                                      <label >Descripión de la publicación:</label>
                                      <textarea className="form-control" rows="6" id="descrip_publi_edit" name="descrip_publi_edit" value={form.descrip_publi_edit}  onChange={this.handleChange} >{form.descrip_publi_edit}</textarea>                     
                                    </div>                 
                              </div>                   
            
                        </div>            
            
                  </div>
            
                  <div className="modal-footer justify-content-between">
                    <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.Editar_publicacion()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar</button>
                    <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>        
                  </div>
                </div>
                
              </div>
              
            </div>


            <div className="modal fade" id="modal-detallepubli" data-backdrop="static">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header feed-modal-header">
                    <h4 className="modal-title">
                    <img id="image_publi" src={this.state.DataIntitucion.avatar} width= "60" className="rounded-circle" />
                    </h4>
                    <h5><small>{nomInst}</small> <br/> <small><Moment fromNow locale='es'>
                             {fecha_publi}
                          </Moment> 
                    </small> </h5> 
                    
                    
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" >×</span>
                    </button>
                  </div>

                  <div className="modal-body">                    
                      

                          <div className="row justify-content-md-center" id="tabla_imgsdetalle"> 
          
                                <div className="col col-lg-12">    
                                    
                                
                                  <img id="imgsdetalle" src={img_completa} alt="Detalle de la publicación" className="rounded"/>
                                  <video id="vdsdetalle" src={img_completa} className="rounded" controls autoPlay />

                                </div>   
                          </div>        
                      
            
                  </div>
            
                </div>
                
              </div>
              
            </div>


            <div className="modal fade" id="modal-eliminar_publicacion" data-backdrop="static">

                <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                    <div className="modal-header feed-modal-header">
                      <h4 className="modal-title"><b>Atención</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" onClick={()=> this.DropDetalle_imagen()}>×</span>
                      </button>
                    </div>
                    <div className="modal-body">                 
  
                          <div className="col-md-12">

                            Si eliminas la publicación no se podrá recuperar.

                            <br></br>
                            <br></br>
  
                            ¿Estás seguro que la deseas eliminar?
  
                          </div>
                                 
                    </div>
          
                          <div className="modal-footer justify-content-between">        
                             <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={()=> this.Borrar_publicacion()}>Si</button>
                             <button type="button" className="btn btn-danger" data-dismiss="modal">No</button>
                          </div>
                  </div>                
                </div>
            
              </div>


      </div>

    )

  }
  
}



export default Publicaciones;